import { render, staticRenderFns } from "./myShop.vue?vue&type=template&id=1bb0f9ac&scoped=true"
import script from "./myShop.vue?vue&type=script&lang=js"
export * from "./myShop.vue?vue&type=script&lang=js"
import style0 from "./myShop.vue?vue&type=style&index=0&id=1bb0f9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0f9ac",
  null
  
)

export default component.exports